// extracted by mini-css-extract-plugin
module.exports = {"section":"estimatePayment_section__UFw6D","hide":"estimatePayment_hide__nQI2d"};